import {
  message
} from "antd";
import { BaseModel, HeantenantModel } from "../model";
// import { ZNRUNPAY_BASE_LOGO_IMG } from "../assets/images";
import { sysLangOpt } from "../options/systemlanguage";


export const exportPubFiles = (data: Blob, fileName: string) => {
  // 这里是全局方法的具体实现
  // Get ready
  const u = URL.createObjectURL(data);
  const _link = document.createElement('a');

  // Set attrs
  _link.download = fileName;
  _link.href = u;
  _link.style.display = 'none';
  document.body.append(_link);

  // Action download
  _link.click();

  // Clean
  URL.revokeObjectURL(u);
  document.body.removeChild(_link);
};

/** 解析 blob 导出接口的错误信息（后端常以 JSON 错误体返回） */
export const readBlobExportError = async (error: any, fallback = '导出失败'): Promise<string> => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const json = JSON.parse(text);
      if (json?.msg) {
        if (json.msg === 'Export data not found' || json.msg === '导出数据为空') {
          return '导出失败,数据为空';
        }
        return json.msg;
      }
    } catch (e) {
      // ignore parse error
    }
  }
  return error?.response?.data?.msg || error?.message || fallback;
};

export function debounce(
  fn: (...args: any[]) => void, _this: unknown, delay: number = 0
): (...args: any[]) => void {
  let timer: NodeJS.Timeout;
  return function (...args: []) {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.call(_this, ...args)
    }, delay)
  }
}

export const getLoginUserInfo = (): BaseModel["LoginResp"] | null => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");

  if (loginUserinfo) {
    try {
      return JSON.parse(loginUserinfo) as BaseModel["LoginResp"];
    } catch (error) {
      console.error("Error parsing loginUserinfo:", error);
      return null;
    }
  }
  return null;
};

export const permissshow = (premissscode: string): boolean => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");
  if (!loginUserinfo) {
    return false;
  }
  const userinfoobj: BaseModel["LoginResp"] = JSON.parse(loginUserinfo) as BaseModel["LoginResp"];
  if (userinfoobj.premissionCodes.length === 0) {
    return false;
  }
  return userinfoobj.premissionCodes.includes(premissscode);
};

export const ismain = (): boolean => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");
  if (!loginUserinfo) {
    return false;
  }
  const userinfoobj: BaseModel["LoginResp"] = JSON.parse(loginUserinfo) as BaseModel["LoginResp"];

  return userinfoobj.ismain;
};

/** 代理商角色 id，与后端 defaultParams.agentId 保持一致 */
export const AGENT_ROLE_ID = "1937073803272323074";

/** 当前登录角色是否可切换商户（租户管理员 / 代理商；切换态看真实身份） */
export const canSwitchAccount = (): boolean => {
  const userinfo = getLoginUserInfo();
  if (!userinfo) {
    return false;
  }
  if (userinfo.impersonating) {
    return true;
  }
  if (userinfo.ismain) {
    return true;
  }
  const roleIds = (userinfo.roleIds || "").split(",").map((v) => v.trim()).filter(Boolean);
  return roleIds.includes(AGENT_ROLE_ID);
};

export const isImpersonating = (): boolean => {
  return Boolean(getLoginUserInfo()?.impersonating);
};

export const getToken = (): string => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");
  if (!loginUserinfo) {
    return "";
  }
  const userinfoobj: BaseModel["LoginResp"] = JSON.parse(loginUserinfo) as BaseModel["LoginResp"];

  return userinfoobj.token;
};

/** 会话级请求签名密钥，登录/切换账号时由后端下发、随 loginUserinfo 存储。 */
export const getSignKey = (): string => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");
  if (!loginUserinfo) {
    return "";
  }
  const userinfoobj: BaseModel["LoginResp"] = JSON.parse(loginUserinfo) as BaseModel["LoginResp"];
  return userinfoobj.signKey || "";
};

/** 写入剪贴板：优先 Clipboard API（需 https/localhost），失败则用 textarea + execCommand */
async function writeTextToClipboard(text: string): Promise<boolean> {
  if (typeof window === "undefined" || !text) {
    return false;
  }
  if (window.isSecureContext && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* 继续降级 */
    }
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.cssText =
      "position:fixed;left:-9999px;top:0;width:1px;height:1px;padding:0;border:none;outline:none;box-shadow:none;background:transparent;font-size:16px;";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export type CopyTextOptions = {
  successText?: string;
  failText?: string;
};

/** 复制到剪贴板并提示；可选自定义成功/失败文案 */
export const copyText = (textToCopy: string, options?: CopyTextOptions) => {
  void writeTextToClipboard(textToCopy).then((ok) => {
    if (ok) {
      message.success(options?.successText ?? "复制成功");
    } else {
      message.error(options?.failText ?? "复制失败，请手动复制");
    }
  });
};

export const textOption = <T extends { value: number | string; label: string }>(opt: T[], key: number | string): string | undefined => {
  const found = opt.find(item => item.value === key);
  return found ? found.label : undefined; // 找到对应项则返回 label，否则返回 undefined
};

export const generateRandomPassword = (length: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*_-+=<>?';
  let password = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    password += characters[randomIndex];
  }
  return password;
};

/** 同步判断小屏；勿用 Hook，可在 Table render / 条件 JSX / 事件里安全调用 */
export const IsSmallScreen = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.matchMedia("(max-width: 767px)").matches;
}

/** 列表表格手机端：关闭 virtual、允许横滑、紧凑行高（非 Hook，可在 JSX 中直接展开） */
export const tableAdaptProps = () => {
  const small = typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
  return {
    virtual: !small,
    size: (small ? "small" : "middle") as "small" | "middle",
    scroll: { x: "max-content" as const },
  };
}

export const reactConfig = () => {

  const tenantStr = localStorage.getItem("tenant");
  const teant = tenantStr ? JSON.parse(tenantStr) as HeantenantModel["tenantDetail"] : null;

  let teantConfig = {
    // iconUrl: `${process.env.PUBLIC_URL}/znrunpay-base-logo.png`,
    title: `xflypay`,
    // baseLogo: ZNRUNPAY_BASE_LOGO_IMG
  }
  if(teant?.faviconLogo) {
    // teantConfig.iconUrl = teant?.faviconLogo
  }
  if(teant?.tenantName) {
    teantConfig.title = teant?.tenantName
  }
  if(teant?.teantLogo) {
    // teantConfig.baseLogo = teant?.teantLogo
  }

  // const hostname = window.location.hostname;
  // let iconUrl = `${process.env.PUBLIC_URL}/znrunpay-base-logo.png`;
  // let title = `xflypay`;
  // let baseLogo = ZNRUNPAY_BASE_LOGO_IMG;

  // if (hostname.includes('xflypay.com')) {
  //   iconUrl = `${process.env.PUBLIC_URL}/xfly-title-logo.png`;
  //   title = `xflypay`;
  //   baseLogo = `${process.env.PUBLIC_URL}/xfly-base-logo1.png`;
  // }
  //  iconUrl = `${process.env.PUBLIC_URL}/xfly-title-logo.png`;
  //   title = `xflypay`;
  //   baseLogo = `${process.env.PUBLIC_URL}/xfly-base-logo.png`;
  return teantConfig;
}

export const langShowText = (text: string): string => {
  const userinfo = getLoginUserInfo();
  const lang = userinfo?.language ?? 'zh-cn';

  // 使用类型断言，确保类型安全
  const langData = (sysLangOpt as Record<string, Record<string, string>>)[lang] || sysLangOpt['zh-cn'];
  return langData[text] || text;
};